module.exports = __webpack_public_path__ + "img/eleve.8ccf1cb5.jpg";